// @ts-nocheck

import { __ } from '../i18n/l10n';
import { VoidReasons } from '../types/history';

export const BetslipByPage = 10;

// https://gitlab.dev.winamax.fr/betting-clients/winabet/-/issues/601
export const HistoryBreakLinesLimit = 40;

export const HistoryEntitiesBetslipKeys = ['nbBetslips', 'betslipIds', 'betslips'];

export const VoidReasonLabels = {
  [VoidReasons.FORMAT_CHANGE]: __('Format change'),
  [VoidReasons.CANCELLED_EVENT]: __('Event cancelled'),
  [VoidReasons.MATCH_ENDED_IN_WALKOVER]: __('Walkover'),
  [VoidReasons.RETIRED_OR_DEFAULTED]: __('Retired or defaulted'),
  [VoidReasons.EVENT_REALLY_ABANDONED]: __('Event abandoned'),
  [VoidReasons.EVENT_REALLY_POSTPONED]: __('Event postponed'),
  [VoidReasons.TOP_30_SKI]: __('Non-top 30 competitor'),
  [VoidReasons.TOP_10_AUTO]: __('Non-top 10 competitor'),
  [VoidReasons.GOALSCORER_GUARANTEE]: __('Goalscorer Guarantee'),
  [VoidReasons.STARTING_5_GUARANTEE]: __('Starting 5 Guarantee'),
  [VoidReasons.ANJ_FORBIDDEN]: __('Prohibited'),
  [VoidReasons.ANJ_TOP_50_FIFA]: __('Prohibited'),
  [VoidReasons.ANJ_NO_ENJEU]: __('Prohibited (no-stakes game)'),
  [VoidReasons.DEAD_HEAT_FACTOR]: __('Dead-Heat'),
};
